<section id="hero" class="relative overflow-hidden bg-surface pt-16 pb-24 lg:pt-24 lg:pb-32">
  <div class="site-container grid grid-cols-1 items-center gap-16 lg:grid-cols-2">
    <div class="space-y-10">
      <div class="flex flex-wrap gap-3">
        @for (badge of content.badges; track badge; let first = $first) {
          <span
            class="rounded-full border border-line bg-canvas/60 px-4 py-1.5 text-[10px] font-black tracking-widest uppercase"
            [class.text-primary]="first"
            [class.text-muted]="!first"
          >
            {{ badge }}
          </span>
        }
      </div>

      <h1 class="text-4xl leading-[1.1] font-bold tracking-tight sm:text-5xl lg:text-7xl">{{ content.title }}</h1>

      <p class="max-w-2xl text-xl leading-relaxed text-muted">{{ content.description }}</p>

      <ul class="space-y-4">
        @for (item of content.highlights; track item) {
          <li class="flex items-center gap-3">
            <app-icon name="check_circle" [filled]="true" class="text-gold" />
            <span class="font-bold text-primary">{{ item }}</span>
          </li>
        }
      </ul>

      <div class="flex flex-wrap gap-4 pt-4">
        <a
          appSectionLink="contato"
          class="rounded-md bg-primary px-8 py-4 text-lg font-bold text-white shadow-lg transition-all hover:bg-primary-hover"
        >
          {{ content.primaryCta }}
        </a>
        <a
          appSectionLink="evidencias"
          class="flex items-center gap-2 rounded-md px-8 py-4 font-bold text-primary transition-all hover:bg-canvas"
        >
          <app-icon name="play_circle" />
          {{ content.secondaryCta }}
        </a>
      </div>
    </div>

    <!-- Mockup: Dashboard de Governança (dados fictícios) -->
    <div class="relative" aria-hidden="true">
      <div class="overflow-hidden rounded-xl border border-line bg-surface p-6 shadow-2xl">
        <div class="mb-8 flex items-center justify-between">
          <p class="font-display text-lg font-bold text-primary">Dashboard de Governança</p>
          <div class="flex gap-2">
            <span class="size-3 rounded-full bg-danger"></span>
            <span class="size-3 rounded-full bg-gold"></span>
            <span class="size-3 rounded-full bg-primary"></span>
          </div>
        </div>

        <div class="mb-8 grid grid-cols-2 gap-4">
          <div class="rounded-lg border border-line bg-canvas/60 p-4">
            <p class="mb-1 text-[10px] font-black tracking-widest text-muted uppercase">Status Global</p>
            <p class="font-display text-3xl font-bold text-primary">94.2%</p>
            <p class="text-xs font-bold text-gold">+2.1% este mês</p>
          </div>
          <div class="rounded-lg border-l-4 border-danger bg-canvas/60 p-4">
            <p class="mb-1 text-[10px] font-black tracking-widest text-muted uppercase">Pendências</p>
            <p class="font-display text-3xl font-bold text-danger">12</p>
            <p class="text-xs font-bold text-muted">Ação imediata</p>
          </div>
        </div>

        <div class="space-y-4">
          <div class="flex items-center justify-between gap-3 border-b border-line p-3">
            <div class="flex items-center gap-3">
              <span class="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary text-xs font-bold text-white">DR</span>
              <div>
                <p class="text-sm font-bold text-primary">Dr. Ricardo Almeida</p>
                <p class="text-[10px] font-bold text-muted uppercase">Cardiologia • CRM/SP 123456</p>
              </div>
            </div>
            <span class="shrink-0 rounded-full bg-danger/10 px-2 py-1 text-[9px] font-black text-danger uppercase">CRM Vencido</span>
          </div>
          <div class="flex items-center justify-between gap-3 border-b border-line p-3">
            <div class="flex items-center gap-3">
              <span class="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary text-xs font-bold text-white">ML</span>
              <div>
                <p class="text-sm font-bold text-primary">Dra. Maria Luiza</p>
                <p class="text-[10px] font-bold text-muted uppercase">Intensivista • CRM/SP 987654</p>
              </div>
            </div>
            <span class="shrink-0 rounded-full bg-gold-50 px-2 py-1 text-[9px] font-black text-gold-700 uppercase">Conforme</span>
          </div>
        </div>
      </div>
      <div class="absolute -bottom-10 -left-10 -z-10 size-64 rounded-full bg-primary/5 blur-3xl"></div>
    </div>
  </div>
</section>
